<template>
  <div class="button-switch-control">
    <span class="button-switch-label">
      <slot />
    </span>
    <div
      class="button-switch"
      :class="{ enabled: isEnabled }"
      :style="{'--color': color}"
      @click="$emit('toggle', !isEnabled)">
      <div class="button" />
      <i
        class="button-icon n-i"
        :class="{ 'n-i-check-d': isEnabled, 'button-icon-right n-i-close-b': !isEnabled }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ButtonSwitch',
  model: {
    prop: 'isEnabled',
    event: 'toggle',
  },
  props: {
    isEnabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: false,
      default: '#80c45a',
    },
  },
};
</script>

<style lang="scss" scoped>
.button-switch-control {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 35px;
  padding: 0 10px;
  background-color: #f3f5f6;
  border: 1px solid #d3dadd;
  border-radius: 2px;

  .button-switch {
    $switch-button-height: 1.2rem;
    $switch-button-color: var(--color);
    $switch-button-color-disabled: #808b9c;
    $switch-button-border-thickness: 2px;
    $switch-transition: all 0.2s ease-in-out;
    $button-side-length: calc(#{$switch-button-height} - (2 * #{$switch-button-border-thickness}));

    position: relative;
    height: $switch-button-height;
    width: calc(#{$switch-button-height} * 2);
    background-color: #808b9c;
    border: $switch-button-border-thickness solid $switch-button-color-disabled;
    border-radius: 2px;
    transition: $switch-transition;
    cursor: pointer;

    .button {
      height: $button-side-length;
      width: $button-side-length;
      border-radius: 2px;
      background-color: #afb7bf;
      transition: $switch-transition;
    }

    &.enabled {
      background-color: $switch-button-color;
      box-shadow: none;
      border-color: $switch-button-color;

      .button {
        background-color: #ddeed6;
        border-color: $switch-button-color;
        transform: translateX(
          calc(#{$button-side-length} + (2 *#{$switch-button-border-thickness}))
        );
      }
    }

    .button-icon {
      position: absolute;
      top: 2px;
      font-size: 12px;
      color: #fff;
      left: 3px;
      &.button-icon-right {
        left: auto;
        right: 3px;
      }
    }
  }

  .button-switch-label {
    margin-right: 50px;
  }
}
</style>
